//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import QFabricModal from "@/components/q-fabric-modal.vue";
import defaultUserImage from "@/assets/images/user.svg";
import { $http } from "../../assets/js/appFunc";

export default {
    components: {
        QFabricModal
    },
    data() {
        return {
            opened: false
        };
    },
    computed: {
        ...mapGetters("userProfile", [
            "userProfileImage",
            "userCookieInfo"
        ]),
        getUserFirstAndLastName() {
            let name = "";

            if (this.userCookieInfo.userFirstName) {
                name += this.userCookieInfo.userFirstName;
            }

            if (this.userCookieInfo.userLastName) {
                name += ` ${this.userCookieInfo.userLastName}`;
            }

            if (!this.userCookieInfo.userFirstName && !this.userCookieInfo.userLastName) {
                name += this.userCookieInfo.userEmail;
            }

            return name;
        },
        computedUserProfileImage() {
            return this.userProfileImage;
        }
    },
    created() {

    },
    methods: {
        openDialog() {
            this.opened = true;
        },

        afterHide() {
            this.$emit("input", false);
        },
        action() {
            this.opened = false;
        },
        toProfile() {
            this.$router.push("/userProfile");
            this.opened = false;
        },
        onProfileImageError(ev) {
            ev.target.src = defaultUserImage;
        },
        logout() {
            $http({
                url: "/auth/logout",
                type: "GET"
            }, true)
                .then(
                    () => { window.location.href = "/"; },
                    () => { window.location.href = "/"; }
                )
                .catch(() => {
                    window.location.href = "/";
                });
        }
    }
};
